import React from 'react';
import Humanize from 'humanize-plus'
import { ColumnProps } from 'antd/es/table';
import { FORMAT_TYPES, ItemFormat } from './types';

const SEPARATOR_CHARACTER = '&#&';
const EMPTY_VALUE = ' - ';
const COLON = ': ';
const EMPTY_STRING = '';
const MONEY_SYMBOL = '$ ';

const isValid = (attrib: any) => attrib !== null && attrib !== undefined;

const capitalize = (word: string) =>
  word[0].toUpperCase().concat(word.slice(1).toLowerCase()).replace(/_/g, ' ');

const getTitleByDataIndex = (columns: ColumnProps<any>[], key: string): string => {
  const dataItem = columns.find(item => item.dataIndex === key);

  if (dataItem && dataItem.title) {
    return String(dataItem.title);
  }

  return capitalize(key);
};

const addNewLine = (value: string) => value.concat(SEPARATOR_CHARACTER);

const getFormatValue = (item: any, itemType: FORMAT_TYPES | null) => {
  if (itemType === FORMAT_TYPES.money) {
    return MONEY_SYMBOL.concat(Humanize.formatNumber(item, 2));
  }

  return item;
}

const getItemTypeFormat = (columnsFormat: ItemFormat[] | undefined, key: string): FORMAT_TYPES | null => {
  if (!columnsFormat || columnsFormat.length === 0) {
    return null;
  }

  const columnFormat = columnsFormat.find(item => item.column === key);
  if (!columnFormat){
    return null;
  }

  return columnFormat.format;
}

const getColumnItemValue = (item: any, columnsFormat: ItemFormat[] | undefined, key: string) => {
  if (isValid(item)) {
    const itemTypeFormat = getItemTypeFormat(columnsFormat, key);
    return getFormatValue(item, itemTypeFormat);
  }

  return EMPTY_VALUE;
}

const buildResponsiveData = (
  isMobile: boolean,
  data: any[],
  columns: ColumnProps<any>[],
  columnsFormat: ItemFormat[] | undefined,
  ): any[] => {
  if (!isMobile) {
    return data;
  }

  const dataIndexes = columns
    .filter((item) => {
      //@ts-ignore
      return !item?.isNotResponsive
    })
    .map((item) => item.dataIndex);

  const dataConverter = (data: any) => {
    const analyzedData = { ...data };

    const keys = Object.keys(analyzedData);
    const values = Object.values(analyzedData)
      .map((item, index) => {
        const key = keys[index];

        if (!dataIndexes.includes(`${key}`) || Array.isArray(item) || item instanceof Object) {
          return null;
        }

        return addNewLine(`${getTitleByDataIndex(columns, key)}${COLON}${getColumnItemValue(item, columnsFormat, key)}`);
      }).filter(item => !!item).join(EMPTY_STRING);

    return { values, ...data };
  };

  return data.map((item: any) => dataConverter(item));
};

const buildResponsiveColumns = (isMobile: boolean, columns: ColumnProps<any>[]):  ColumnProps<any>[] | any => {
  if (!isMobile) {
    return columns;
  }

  const action = columns.find((column: ColumnProps<any>) => {
    //@ts-ignore
    return column?.isNotResponsive
  });

  return [
    {
      title: 'Information',
      dataIndex: 'values',
      key: 'values',
      render: (values: string) => (
        <div>
          {values.split(SEPARATOR_CHARACTER).filter(item => item !== EMPTY_STRING).map((item: string, index: number) => {
            const line = item.split(COLON);
            return (
              <p key={`p-${index + 1}`}><strong>{line[0].concat(COLON)}</strong>{line[1]}</p>
            )
          })}
        </div>
      ),
    },
    action
  ];
};

export { buildResponsiveColumns, buildResponsiveData };
